import React from 'react';
import { DokaModal, toURL } from '../react-doka';
import Button from "react-bootstrap/Button";
import ClampLines from 'react-clamp-lines';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './ImageBusiness.css';

class ImageBusiness extends React.Component {
    
    constructor(props) {
        super(props);

       //console.log("******Profile Image props: " + JSON.stringify(props));

        var imageSrc = "https://sert-consumer.s3.amazonaws.com/images/file_upload.png";
        if (props.imageSrc) {
            imageSrc = props.imageSrc;
        }

        this.state = {
            
            profile: {
                enabled: false,
                image: imageSrc,
                src: props.imageSrc ? props.imageSrc : null,
                srcPrev: null,
                crop: {
                    aspectRatio: 1,
                },
                stickers: props.stickers
            }
        };

        this.handleDokaConfirmProfile = this.handleDokaConfirmProfile.bind(this);
        this.handleDokaCancelProfile = this.handleDokaCancelProfile.bind(this);
        this.handleToggleProfileEditor = this.handleToggleProfileEditor.bind(this);
        this.handleFileChangeProfile = this.handleFileChangeProfile.bind(this);
    }

    /**
     * Profile Picture
     */
    handleToggleProfileEditor() {

        console.log('Toggle Doka Profile Modal');

        this.setState({
            profile: {
                ...this.state.profile,
                enabled: !this.state.profile.enabled
            }
        });
    }

    handleFileChangeProfile(e) {
        try {
            if (!e.target.files.length) return;

            console.log('File Change Doka Profile');

            this.setState({
                profile: {
                    ...this.state.profile,
                    srcPrev: this.state.profile.src,
                    src: e.target.files[0],
                    enabled: true
                }
            });
        } catch (e) {}
    }

    handleDokaConfirmProfile(output) {

        console.log('Confirmed Doka Profile Modal', output);

        this.setState({
            profile: {
                ...this.state.profile,
                srcPrev: null,
                enabled: false,
                image: output.file,
                crop: output.data.crop
            }
        });

        this.props.setImageObject(output);
    }

    handleDokaCancelProfile() {

        console.log('Cancelled Doka Profile Modal');

        this.setState({
            profile: {
                ...this.state.profile,
                src: this.state.profile.srcPrev || this.state.profile.src,
                srcPrev: null,
                enabled: false
            }
        });
    }

    render() {
        const { profile } = this.state;
        return (
            <div className="BusinessImage">
                <div className="businessImage row-bottom-20">
                    <div className="businessImage-container">
                        <div className="businessImage-profileImage">
                            <div className="ProfileImage">
                
                                <div className="profile">
                                    { /*!profile.enabled && <button onClick={ this.handleToggleProfileEditor }>Edit Photo</button> */}
                                    { /*!profile.enabled && <input type="file" accept="image/*" onChange={ this.handleFileChangeProfile }/> */}
                                    <img src={ toURL(profile.image) } alt=""/>
                                </div>

                                { profile.enabled && <DokaModal 
                                    utils={['crop', 'filter', 'color']}
                                    src={ profile.src }
                                    cropAspectRatio={1}
                                    crop={ profile.crop }
                                    /*cropMask={ mask }*/
                                    outputData={ true }
                                    outputWidth={750}
                                    outputHeight={750}
                                    imagePreviewScaleMode={"image"}
                                    //stickers={profile.stickers} - remove ability to add stickers
                                    labelButtonUtilSticker={"Stamps"}
                                    onConfirm={ this.handleDokaConfirmProfile }
                                    onCancel={ this.handleDokaCancelProfile }/> }

                            </div>
                        </div>
                        <div className="businessImage-story">
                            <ClampLines
                                text={this.props.story}
                                id="story-preview-id"
                                lines={5}
                                ellipsis="..."
                                buttons={false}
                                className="custom-class"
                                innerElement="p"
                            />
                        </div>
                    </div>
                </div>
                <div className="ImageButtons row-top-20 left-text ">
                    <div className="linkBtn" onClick={this.handleFileChangeProfile}>
                        <span><input type="file" accept="image/*" onChange={ this.handleFileChangeProfile }/></span>
                        <Button onClick={(e) => this.handleFileChangeProfile(e)}>
                            <FontAwesomeIcon icon="plus-circle"></FontAwesomeIcon> 
                        </Button>
                        <div className="linkBtn-link" >
                            {   /* if src is available, change language to Replace photo instead of Add Photo */
                                !profile.enabled && profile.src && ( 
                                    <>Update photo</>
                            )}
                            {   /* if src is not available, change language to Replace photo instead of Add Photo */
                                !profile.enabled && !profile.src && ( 
                                    <>Add photo</>
                            )}
                        </div>
                    </div>
                    {   /* Only offer Edit button if an src picture is available */
                        !profile.enabled && profile.src && ( 
                        <div className="left-text linkBtn"> 
                            <Button onClick={(e) => this.handleToggleProfileEditor(e)}>
                                <FontAwesomeIcon icon="user-edit"></FontAwesomeIcon> 
                            </Button>
                            <div className="linkBtn-link" onClick={this.handleToggleProfileEditor}>Edit photo</div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default ImageBusiness;